

import { Component, Inject, OnInit, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Clipboard } from '@angular/cdk/clipboard';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { safeLocalStorage, safeSessionStorage } from '@shared/safe-web-storage';

const localStorage = safeLocalStorage;
const sessionStorage = safeSessionStorage;



import Swal from 'sweetalert2';
import { ProductoModel } from '../../../Models/productoModel';
import { CarritoModel } from '../../../Models/carritoModel';
import { ProductosServicesService } from '../../../Services/productos-services.service';
import { CarritoService } from '../../../Services/carrito.service';
import { ComunicacionService } from '../../../Services/comunicacion.service';
import { WishService } from '../../../Services/wish.service';
import { MessagesService } from '../../../Services/messages.service';
import { Breadcrumb } from '@models/breadcrumb.model';
import { AnalyticsService } from '@services/analytics.service';
import { SeoService } from '@services/seo.service';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { categoryPath, productId, productPath } from '@services/seo-url.util';
import { PRODUCT_IDS_BY_SLUG } from '@services/seo-routes.data';


@Component({
  selector: 'app-detalle-productos',
  templateUrl: './detalle-productos.component.html',
  styleUrls: ['./detalle-productos.component.css'],
  standalone: false
})
export class DetalleProductosComponent implements OnInit, OnDestroy {
  private routeSub!: Subscription;
  public cargando: boolean = true;
  public  Dp :Array<ProductoModel>=[];//Detalle Producto
  public Imagenes:Array<any>=[];
  public ModelSelected:any;
  public CantidadModelo!:number;
  public carrito:CarritoModel[] = [];
  public lsProdRec:any=[];
  public Comentarios:any=[];
  public formOpinion: UntypedFormGroup;
  public guardandoOpinion = false;
  public paramId: string='';
  public IdProd: string = '0';
  public IdUsuario: string = '0';
  public precioCliente:string='0';
  private owlCarouselLoaded?: Promise<void>;
  public readonly socialProfiles = [
    {
      label: 'Instagram',
      url: 'https://www.instagram.com/claveinstrumentosmusica',
      icon: 'bx bxl-instagram-alt'
    },
    {
      label: 'Facebook',
      url: 'https://www.facebook.com/239591079577745',
      icon: 'bx bxl-facebook-circle'
    },
    {
      label: 'TikTok',
      url: 'https://www.tiktok.com/@clavetreto',
      icon: 'bx bxl-tiktok'
    }
  ];

  constructor(protected ProdServ: ProductosServicesService,private modal:NgbModal,
              protected carServices:CarritoService,public router: Router, private clipboard: Clipboard,
              public comunicaservices:ComunicacionService,protected rt:ActivatedRoute,@Inject(DOCUMENT) document: any,
              private wsService:WishService,private msg:MessagesService,
              private analytics: AnalyticsService,
              private seo: SeoService,
              private breadcrumbService: BreadcrumbService,
              private formBuilder: UntypedFormBuilder,
              @Inject(PLATFORM_ID) private platformId: object) {
    this.IdUsuario = this.isBrowser ? sessionStorage.getItem("IdUsuario") || '0' : '0';
    this.formOpinion = this.createReviewForm();
  }

  ngOnInit() {
    this.precioCliente = this.isBrowser ? sessionStorage.getItem("precioCliente") || '1' : '1';
    this.getcarritoLocal();
    if (this.isBrowser) this.GetProductosRecomendados();

    // Carga inicial
    const initialSlug = this.rt.snapshot.paramMap.get('slug');
    const initialId = this.rt.snapshot.paramMap.get('id')
      || PRODUCT_IDS_BY_SLUG[initialSlug || ''];
    if (initialSlug && !initialId) {
      this.router.navigateByUrl('/productos', { replaceUrl: true });
      return;
    }
    this.IdProd = initialId || (this.isBrowser ? sessionStorage.getItem("IdProd") : null) || '0';
    this.DatosProducto();
    this.loadProductDetailScript();

    // Escucha mensajes del buscador del header (mismo patrón que detalleProducto)
    this.routeSub = this.comunicaservices.enviarMensajeObservable.subscribe(msg => {
      if (msg.startsWith('verProducto:')) {
        const newId = msg.replace('verProducto:', '');
        this.IdProd = newId;
        this.cargando = true;
        this.DatosProducto();
        this.loadProductDetailScript();
      }
    });
  }

  ngOnDestroy() {
    this.routeSub?.unsubscribe();
  }

  getcarritoLocal() {
    if (!this.isBrowser) return;

    if (localStorage.getItem('carrito') !== null) {
      this.carrito = JSON.parse(localStorage.getItem('carrito') || "");
    }
  }

  CargaImg(Indice: any) {
    this.Imagenes = [];
    this.Imagenes = this.Dp?.[0]?.Modelos?.[Indice]?.Imagenes || [];
  }

  // -------------- Logica para stock --------------
  // mostrar candidad seleccionada y personalizada
  public cantidadSeleccionada: number = 1;
  public cantidadPersonalizada: string = '';
  public mostrarDropdown: boolean = false;

  // Opciones rápidas de cantidad
  get opcionesCantidad() {
    const opciones = [
      { label: '1 unidad', value: 1 },
      { label: '2 unidades', value: 2 },
      { label: '3 unidades', value: 3 },
      { label: '4 unidades', value: 4 },
      { label: '5 unidades', value: 5 },
      { label: '10 unidades', value: 10 }
    ];
    return opciones.filter(op => op.value <= this.stockDisponible);
  }

  // Stock disponible de la variante seleccionada
  get stockDisponible(): number {
    return this.ModelSelected?.Stock ?? 0;
  }

  // mostrar el texto adecuado según el stock
  get stockDisplay(): string {
    const stock = this.stockDisponible;
    // if (stock === 0) return 'No disponible';
    if (stock > 10) return '+ 10';
    return stock.toString();
  }

  // Mostrar/ocultar el selector de cantidad según el stock
  get mostrarSelectorCantidad(): boolean {
    return this.stockDisponible > 0;
  }

  seleccionarCantidad(valor: number) {
    this.cantidadSeleccionada = valor;
    this.CantidadModelo = valor;
    this.cantidadPersonalizada = '';
    this.mostrarDropdown = false;
  }

  private resetCantidadSeleccionada() {
    const cantidadInicial = this.stockDisponible > 0 ? 1 : 0;
    this.cantidadSeleccionada = cantidadInicial;
    this.CantidadModelo = cantidadInicial;
    this.cantidadPersonalizada = '';
    this.mostrarDropdown = false;
  }

  // Aplicar cantidad personalizada
  aplicarCantidadPersonalizada() {
    const cantidad = Number(this.cantidadPersonalizada);
    if (this.isCantidadPersonalizadaValida()) {
      this.cantidadSeleccionada = cantidad;
      this.CantidadModelo = cantidad;
      this.mostrarDropdown = false;
    }
  }

  // Validar cantidad personalizada (solo enteros positivos y <= stock)
  isCantidadPersonalizadaValida(): boolean {
  const cantidad = Number(this.cantidadPersonalizada);
    return (
      !!this.cantidadPersonalizada &&
      Number.isInteger(cantidad) &&
      cantidad > 0 &&
      cantidad <= this.stockDisponible
    );
  }

  // Solo permitir números en el input personalizado
  onInputCantidadPersonalizada(event: any) {
    // Solo permite números enteros positivos
    const valor = event.target.value.replace(/[^0-9]/g, '');
    this.cantidadPersonalizada = valor;
  }

// -------------- end Logica para stock --------------

  async AgregaProducto(VentaRapida = 0) {
    const stock = this.stockDisponible;

    if (stock <= 0) {
      this.msg.mensajeRapido("Este producto no tiene stock disponible", "Atención", "warning");
      return;
    }

    if (!this.CantidadModelo || this.CantidadModelo > stock) {
      this.CantidadModelo = Math.min(Math.max(this.CantidadModelo || 1, 1), stock);
      this.cantidadSeleccionada = this.CantidadModelo;
    }

    let precio = parseFloat(this.ModelSelected.Precio.toString().replace(/[^\d\.\-]/g, ""));
    if (this.IdUsuario == "0") {
      //validamos si existe el elemento
      this.getcarritoLocal();
      let prodExis = this.carrito.find(prod => prod.IdProductoModelo == this.ModelSelected.IdProductosModelos)
      if (prodExis == null) {//si no existe el producto en el carrito
        if (this.CantidadModelo > stock) {
          this.msg.mensajeRapido("La cantidad solicitada excede el stock disponible", "Atención", "warning");
          return;
        }

        this.carrito.push({
          IdUsuario: 0,
          Cantidad: this.CantidadModelo,
          IdProductoModelo: this.ModelSelected.IdProductosModelos,
          IdProducto: this.Dp[0].IdProducto,
          Precio: precio,
          Total: this.CantidadModelo * precio,
          Imagenes: [{ src: this.productModelImage(this.ModelSelected) }],
          Nombre: this.Dp[0].Nombre,
          Marca: this.Dp[0].Marca,
          Modelo: this.ModelSelected.Modelo,
          Stock: stock
        })
        localStorage.setItem('carrito', JSON.stringify(this.carrito));
      }
      else {
        if (prodExis.Cantidad + this.CantidadModelo > stock) {
          this.msg.mensajeRapido("La cantidad solicitada excede el stock disponible", "Atención", "warning");
          return;
        }

        for (let child of this.carrito) {
          if (child.IdProductoModelo == prodExis.IdProductoModelo) {
            child.Cantidad = prodExis.Cantidad + this.CantidadModelo
            child.Total = child.Cantidad * child.Precio;
            child.Stock = stock;
            child.IdProducto = this.Dp[0].IdProducto;
            child.Imagenes = [{ src: this.productModelImage(this.ModelSelected) }];
            child.Nombre = this.Dp[0].Nombre;
            child.Marca = this.Dp[0].Marca;
            child.Modelo = this.ModelSelected.Modelo;
          }
        }
        localStorage.setItem('carrito', JSON.stringify(this.carrito));

      }
      //document.getElementById("BtnVentanaRegistro")?.click();
    }
    else {
      let response;
      response = await this.carServices.addCarProd([{ IdUsuario: this.IdUsuario, Cantidad: this.CantidadModelo, IdProductoModelo: this.ModelSelected.IdProductosModelos, Precio: precio }]);

    }
    if (VentaRapida == 0)
      this.msg.mensajeRapido("El producto se agregó a tu carrito", "Felicidades", "success");

    this.analytics.addToCart(this.Dp[0], this.ModelSelected, this.CantidadModelo);
    this.comunicaservices.enviarMensaje("actualiza");
  }

  OpenRegistro(contenido: any) {
    this.modal.open(contenido, { size: 'lg' });
  }
  async GetProductosRecomendados() {
    this.lsProdRec = await this.ProdServ.GetProductos(0, 2);
  }

  async DatosProducto(){
    if (this.isBrowser) window.scrollTo(0, 0);
    try {
      const prod: any = await this.ProdServ.GetProductos(this.IdProd, 0);
      this.Dp = Array.isArray(prod) ? prod : [];
      if (!this.Dp[0]) return;

      this.ModelSelected = this.Dp[0].Modelos?.[0] || null;
      this.CargaImg(0);
      this.resetCantidadSeleccionada();
      this.setProductBreadcrumbs();
      await this.obtenComentarios();
      if (this.ModelSelected) this.analytics.viewItem(this.Dp[0], this.ModelSelected);
      this.replaceLegacyUrl();
    } catch (e) {
      console.error('Error cargando producto', this.IdProd, e);
    } finally {
      this.cargando = false;
    }
  }

  public detalleProducto(prod: any) {
    this.IdProd = productId(prod)?.toString() || '0';
    if (this.isBrowser) sessionStorage.setItem('IdProd', this.IdProd);
    this.cargando = true;
    this.router.navigateByUrl(productPath(prod));
    this.DatosProducto();
    this.loadProductDetailScript();
  }

  public ModeloSeleccionado() {
    if (!this.isBrowser) return;

    let index = document.getElementById("ModelSelected") as HTMLSelectElement;
    this.ModelSelected = this.Dp[0].Modelos[index.selectedIndex];
    this.CargaImg(index.selectedIndex);
    this.resetCantidadSeleccionada();
    this.obtenComentarios();

  }


  async obtenComentarios() {
    if (!this.ModelSelected) return;
    try {
      const coment: any = await this.ProdServ.GetOpinionProductos(this.ModelSelected.IdProductosModelos, 0);
      this.Comentarios = Array.isArray(coment) ? coment : [];
    } catch (error) {
      this.Comentarios = [];
      console.error('Error cargando opiniones', error);
    }
    this.updateSeo();
  }

  public get promedioOpiniones(): number {
    if (!this.Comentarios.length) return 0;
    return this.Comentarios.reduce((total: number, item: any) => total + Number(item.Estrellas || 0), 0)
      / this.Comentarios.length;
  }

  public async abrirOpinion(contenido: any) {
    if (this.IdUsuario === '0') {
      this.msg.mensajeRapido('Inicia sesión para escribir una opinión', 'Opiniones', 'info');
      return;
    }

    this.formOpinion = this.createReviewForm();
    try {
      const existente: any = await this.ProdServ.GetOpinionProductos(
        this.ModelSelected.IdProductosModelos,
        Number(this.IdUsuario)
      );
      if (Array.isArray(existente) && existente[0]) {
        this.formOpinion.patchValue({
          Opinion: existente[0].Opinion,
          Estrellas: Number(existente[0].Estrellas)
        });
      }
    } catch {
      // El formulario nuevo sigue disponible si no existe una opinion previa.
    }
    this.modal.open(contenido, { size: 'lg', centered: true });
  }

  public async guardarOpinion() {
    if (this.formOpinion.invalid || this.guardandoOpinion) {
      this.formOpinion.markAllAsTouched();
      return;
    }

    this.guardandoOpinion = true;
    try {
      const resp: any = await this.ProdServ.InsertOpinionProductos(this.formOpinion.value);
      this.modal.dismissAll();
      await this.obtenComentarios();
      this.msg.mensajeRapido(resp?.[0]?.Mensaje || 'Tu opinión se guardó correctamente', 'Opiniones', 'success');
    } catch {
      this.msg.mensajeRapido('No fue posible guardar tu opinión. Verifica que el producto pertenezca a una compra.', 'Opiniones', 'error');
    } finally {
      this.guardandoOpinion = false;
    }
  }

  private createReviewForm(): UntypedFormGroup {
    return this.formBuilder.group({
      Opinion: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]],
      Estrellas: [0, [Validators.required, Validators.min(1), Validators.max(5)]],
      IdCliente: [this.IdUsuario],
      IdProductosModelos: [this.ModelSelected?.IdProductosModelos || 0]
    });
  }
  async addWish(IdP: any) {

    if (this.IdUsuario == '0') {
      this.msg.mensajeRapido("Necesita registrarse o iniciar session para agregarlo a lista", "Atención", "error");
      return;
    }

    if (IdP != '0')
      this.IdProd = IdP;
    const wish = {
      "IdWish": 0,
      "IdUsuario": this.IdUsuario,
      "IdProducto": this.IdProd,
      "Fecha": ""
    }
    await this.wsService.GuardaryEditarWish(wish).then((res: any) => {
      if (res) {
        this.msg.mensajeRapido(res[0].Mensaje, "Atención", "success")
      }
    })
  }
  async ComprarAhora(){
    await this.AgregaProducto(1);
    if (this.isBrowser) sessionStorage.setItem("ventaRapida","1");
    this.router.navigateByUrl('/checkout');
  }

  Compartir() {
    if (!this.isBrowser) return;

    this.clipboard.copy(this.productShareUrl);

    this.msg.mensajeRapido("Se copió el Link correctamente", "Atención", "success");
  }

  public shareProduct(platform: 'whatsapp' | 'facebook' | 'x') {
    if (!this.isBrowser) return;

    const url = encodeURIComponent(this.productShareUrl);
    const text = encodeURIComponent(this.productShareText);
    const shareUrls = {
      whatsapp: `https://wa.me/?text=${text}%20${url}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      x: `https://twitter.com/intent/tweet?text=${text}&url=${url}`
    };

    window.open(shareUrls[platform], '_blank', 'noopener,noreferrer');
  }

  public get productShareUrl(): string {
    if (!this.isBrowser) return this.seo.absoluteUrl(productPath(this.Dp[0] || this.IdProd));
    return `${window.location.origin}${productPath(this.Dp[0] || this.IdProd)}`;
  }

  public get productShareText(): string {
    const product = this.Dp[0];
    return product ? `${product.Nombre} | ${product.Marca} en Clave Winds` : 'Producto Clave Winds';
  }

  private updateSeo() {
    const product = this.Dp[0];
    if (!product) return;

    const model = this.ModelSelected;
    const image = model?.Imagenes?.[0]?.src;
    const price = model?.Precio ? String(model.Precio).replace(/[^\d.\-]/g, '') : undefined;
    const canonicalPath = productPath(product);
    const canonical = this.seo.absoluteUrl(canonicalPath);
    const productSummary = product.DescripcionC || product.DescripcionL || 'Disponible en nuestra tienda en linea.';
    const description = `${product.Nombre}${product.Marca ? ` de ${product.Marca}` : ''}. ${productSummary}`;
    const ratingCount = this.Comentarios?.length ?? 0;
    const ratingValue = ratingCount
      ? this.Comentarios.reduce((total: number, item: any) => total + Number(item.Estrellas || 0), 0) / ratingCount
      : 0;

    this.seo.update({
      title: `${product.Nombre} | ${product.Marca} | Clave Winds`,
      description,
      canonical,
      image,
      imageAlt: [product.Marca, product.Nombre, model?.Modelo].filter(Boolean).join(' '),
      type: 'product',
      price,
      currency: 'MXN',
      availability: Number(model?.Stock ?? 0) > 0 ? 'instock' : 'oos',
      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: product.Nombre,
        brand: product.Marca ? { '@type': 'Brand', name: product.Marca } : undefined,
        description,
        image: image ? [image] : undefined,
        sku: model?.SKU,
        offers: price ? {
          '@type': 'Offer',
          priceCurrency: 'MXN',
          price,
          availability: Number(model?.Stock ?? 0) > 0 ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
          url: canonical
        } : undefined,
        aggregateRating: ratingCount ? {
          '@type': 'AggregateRating',
          ratingValue: Number(ratingValue.toFixed(1)),
          reviewCount: ratingCount
        } : undefined,
        review: ratingCount ? this.Comentarios.map((item: any) => ({
          '@type': 'Review',
          author: { '@type': 'Person', name: item.Nombre || 'Cliente de Clave Winds' },
          reviewBody: item.Opinion,
          datePublished: item.Fecha || item.FechaRegistro || undefined,
          reviewRating: {
            '@type': 'Rating',
            ratingValue: Number(item.Estrellas),
            bestRating: 5,
            worstRating: 1
          }
        })) : undefined
      }
    });
  }

  private setProductBreadcrumbs() {
    const product = this.Dp[0];
    if (!product) return;

    const breadcrumbs: Breadcrumb[] = [];
    const productData = product as any;
    const category = productData.categoriasProductos?.[0] || productData;
    const categoryLabel = category?.DescCategoria || product.Categoria;

    if (categoryLabel) {
      breadcrumbs.push({
        label: categoryLabel,
        url: categoryPath(category)
      });
    }

    breadcrumbs.push({
      label: product.Nombre,
      url: productPath(product)
    });

    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }

  public productPath(prod: any): string {
    return productPath(prod);
  }

  public productImageAlt(img: any): string {
    const product = this.Dp[0];
    return img?.Alt || [product?.Marca, product?.Nombre, this.ModelSelected?.Modelo].filter(Boolean).join(' ') || 'Producto Clave Winds';
  }

  private replaceLegacyUrl() {
    if (!this.isBrowser || !this.Dp[0]) return;
    const canonicalPath = productPath(this.Dp[0]);
    const currentPath = this.router.url.split('?')[0];
    if (currentPath !== canonicalPath) {
      this.router.navigateByUrl(canonicalPath, { replaceUrl: true });
    }
  }

  private productModelImage(model: any): string {
    return model?.Imagenes?.[0]?.src
      ?? this.Dp?.[0]?.Imagenes?.[0]?.src
      ?? 'Public/Img/Productos/Default.jpg';
  }

  private loadProductDetailScript() {
    if (!this.isBrowser) return;

    this.ensureOwlCarousel()
      .then(() => $.getScript('/Public/Js/ProductDetail.js'))
      .catch((error) => console.error('Error cargando scripts de producto', error));
  }

  private ensureOwlCarousel(): Promise<void> {
    if ((($.fn as any)?.owlCarousel)) return Promise.resolve();
    if (this.owlCarouselLoaded) return this.owlCarouselLoaded;

    this.owlCarouselLoaded = new Promise((resolve, reject) => {
      $.getScript('/Public/Js/owl.carousel.js')
        .done(() => resolve())
        .fail((_jqxhr: any, _settings: any, exception: any) => reject(exception));
    });

    return this.owlCarouselLoaded;
  }

  private get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }


}
